import { create } from 'zustand';

const KEY = 'seoul-wishlist';

const load = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
};
const save = (products) => {
  try { localStorage.setItem(KEY, JSON.stringify(products)); } catch {}
};

export const useWishlistStore = create((set, get) => ({
  items: load(),

  toggle: (product) => {
    const items = get().items;
    const exists = items.some(p => p.id === product.id);
    const next = exists ? items.filter(p => p.id !== product.id) : [...items, product];
    save(next);
    set({ items: next });
  },

  remove: (productId) => {
    const next = get().items.filter(p => p.id !== productId);
    save(next);
    set({ items: next });
  },

  isLiked: (productId) => get().items.some(p => p.id === productId),
  getCount: () => get().items.length,
}));
